import {INewBusiness} from "@/views/editor/service/business";
import Coupon from "@/views/editor/service/coupon/coupon/index";

export default {'coupon': Coupon} as { [key: string]: INewBusiness }